import {
  createSlice,
  createAsyncThunk
} from '@reduxjs/toolkit'
import { importVehicleApi } from './importVehicleAPI'
const initialState = {
  check: {
    load: false,
    error: {},
    success: {}
  },
  import: {
    load: false,
    data: {}
  }
}

export const importVehicle = createAsyncThunk(
  'vehicle/import',
  async (props, { rejectWithValue }) => {
    try {
      const response = await importVehicleApi({ ...props, exec: true })
      return response.data
    } catch (err) {
      if (err.response.status >= 500) {
        return rejectWithValue({ error: { unknown: true } })
      }
      return rejectWithValue(err.response.data)
    }
  }
)

export const checkVehicle = createAsyncThunk(
  'vehicle/import-check',
  async (props, { rejectWithValue }) => {
    try {
      const response = await importVehicleApi({ ...props, exec: false })
      // console.log('RES', response);
      return response.data
    } catch (err) {
      if (err.response.status >= 500) {
        return rejectWithValue({ error: { unknown: true } })
      }
      return rejectWithValue(err.response.data)
    }
  }
)

export const importVehicleSlice = createSlice({
  name: 'importVehicle',
  initialState,
  reducers: {
    clearState: (state) => {
      state.check.load = false
      state.check.error = {}
      state.check.success = {}
      state.import.data = {}
      return state
    }
  },
  extraReducers: {
    [checkVehicle.fulfilled]: (state, { payload }) => {
      state.check.load = false
      state.check.success = payload
      return state
    },
    [checkVehicle.rejected]: (state, { payload }) => {
      state.check.load = false
      state.check.error = payload.error
    },
    [checkVehicle.pending]: (state) => {
      state.check.load = true
      state.check.success = {}
      state.check.error = {}
      state.import.data = {}
    },
    [importVehicle.fulfilled]: (state, { payload }) => {
      state.import.load = false
      state.import.data = payload
      return state
    },
    [importVehicle.rejected]: (state, { payload }) => {
      state.import.load = false
      state.check.error = payload.error
    },
    [importVehicle.pending]: (state) => {
      state.import.load = true
      state.check.success = {}
      state.import.data = {}
    }
  }
})

export const { clearState } = importVehicleSlice.actions
export default importVehicleSlice.reducer
